import { request } from "../helpers/axios.new";

export const FETCH_ENABLED_WIDGETS = () => {
  return request({
    url: `/widgets?enabled=${true}`,
    method: "GET",
  });
};
